import React from 'react';
import { EPayMethodType } from '../../constants';
import { useConfigAtomValues, useDataAtomValues, useStateAtomValues } from '../../state';
import { usePayHandler, useSettleAmountFormatter } from '../../hooks';
import WeiXinPayModal from '../WeiXinPayModal';
import PayWithCreditModal from '../PayWithCreditModal';
import HuifuWeiXinPayModal from '../HuifuWeiXinModal';
import PayNowModal from '../../components/PayNowModal';
import UMSModal from '../../components/UMSModal';
export default function usePayModules() {
  var _useConfigAtomValues = useConfigAtomValues(),
    WeChatNode = _useConfigAtomValues.WeChatNode;
  var _useDataAtomValues = useDataAtomValues(),
    billDetail = _useDataAtomValues.billDetail;
  var _useStateAtomValues = useStateAtomValues(),
    payMethod = _useStateAtomValues.payMethod;
  /**
   * FIXME: 请注意，usePayHandler 内部由于进行了一系列支付渠道「支付成功、 支付失败、支付校验」等事件的监听，所以不能重复执行。
   * 目前只能把 usePayHandler 执行结果中的「各个回调函数」，通过 props 传入给子组件去使用。
   */
  var usePayHandlerReturns = usePayHandler();
  var settleAmountFormatter = useSettleAmountFormatter();
  var modules = /*#__PURE__*/React.createElement(React.Fragment, null, WeChatNode && /*#__PURE__*/React.isValidElement(WeChatNode) ? WeChatNode : /*#__PURE__*/React.createElement(WeiXinPayModal, {
    priceString: settleAmountFormatter((billDetail === null || billDetail === void 0 ? void 0 : billDetail.settleAmount) || 0, {
      code: billDetail === null || billDetail === void 0 ? void 0 : billDetail.orderCurrency
    }),
    onPayCancel: usePayHandlerReturns.handlePayCancel,
    onPaySuccess: usePayHandlerReturns.handlePaySuccess,
    onError: usePayHandlerReturns.handlePayError
  }), [EPayMethodType.Creditcard, EPayMethodType.Airwallex].includes(payMethod) && /*#__PURE__*/React.createElement(PayWithCreditModal, {
    onPayCancel: usePayHandlerReturns.handlePayCancel,
    onSuccess: usePayHandlerReturns.handlePaySuccess,
    onError: usePayHandlerReturns.handlePayError
  }), /*#__PURE__*/React.createElement(HuifuWeiXinPayModal, {
    priceString: settleAmountFormatter((billDetail === null || billDetail === void 0 ? void 0 : billDetail.settleAmount) || 0, {
      code: billDetail === null || billDetail === void 0 ? void 0 : billDetail.orderCurrency
    }),
    onPayCancel: usePayHandlerReturns.handlePayCancel,
    onSuccess: usePayHandlerReturns.handlePaySuccess
  }), /*#__PURE__*/React.createElement(PayNowModal, {
    onPaySuccess: usePayHandlerReturns.handlePaySuccess,
    onPayFail: usePayHandlerReturns.handlePayError,
    onPayCancel: usePayHandlerReturns.handlePayCancel
  }), /*#__PURE__*/React.createElement(UMSModal, {
    onPayCancel: usePayHandlerReturns.handlePayCancel,
    onPayFail: usePayHandlerReturns.handlePayError
  }));
  return {
    modules: modules,
    payHandlers: usePayHandlerReturns
  };
}